import { css } from '@emotion/core';
import styled from '@emotion/styled';

export const EmptyContentContainer = styled.div`
  display: flex;
  flex: 1;
  height: 100%;
  margin: 24px;
  border-radius: 6px;
  background-color: #ebeced;
`;

export const MusicToolContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: scroll;
  box-shadow: inset 0 0 4px rgba(0, 0, 0, 0.25);
`;

export const SearchBar = styled.div`
  position: relative;
  margin-top: 30px;
  padding: 0 24px;
`;

export const Header = styled.div`
  max-width: 330px;
  margin: 0 auto;
  padding-top: 24px;
  text-align: center;
`;

export const SearchTitle = styled.h3`
  margin-top: 8px;
  margin-bottom: 8px;
  padding-bottom: 0;
  font-size: 1.125rem;
`;

export const SearchBarIconContainer = styled.div`
  position: absolute;
  display: inline-flex;
  width: 14px;
  height: 14px;
  margin-top: 14px;
  margin-left: 16px;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 0 0 0 37px;
  border: 0.75px solid #c9cbcd;
  border-radius: 20px;
  color: #7f8287;
  line-height: 40px;
  background: #ffffff;
  outline: none;
  resize: none;
`;

export const musicSegmentBackground = (coverArt: string) => css`
  margin: 0 auto;
  /* applies album art as PlayButton background */
  /* this !important rule turns the CircleButton into a square */
  border-radius: 0 !important;
  background-image: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.75)
    ),
    url(${coverArt});
  background-size: cover;
  &:hover {
    background-image: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 0),
        rgba(0, 0, 0, 0.25)
      ),
      url(${coverArt});
    background-size: cover;
  }
`;

export const SearchResultPreviewUnavailable = styled.div`
  &:hover > div {
    display: flex !important;
  }
`;

export const StagingAudioPreviewUnavailable = styled.div`
  margin-left: 16px;
  &:hover > div {
    display: flex !important;
  }
`;

export const ButtonWrapper = styled.button<{ backgroundColor: string }>`
  display: grid;
  flex: 0 0 50px;
  width: 50px;
  height: 50px;
  padding: 14px;
  border-radius: 100%;
  background-color: ${({ backgroundColor }) => backgroundColor};
  place-content: center;
`;

export const DollarIconWrapper = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #c9cbcd;
  svg {
    width: 42%;
    padding-top: 4px;
    padding-left: 1px;
  }
`;
